module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00059.38c45e3c.jpg";